export default function Products() {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, quiero cotizar productos de madera con Aserradero Santa Rosa.');
    window.open(`https://wa.me/56981372039?text=${message}`, '_blank');
  };

  const products = [
    {
      name: 'Polines',
      description: 'Ideales para construcción y estructuras. Dimensiones estándar y personalizadas.',
      image: 'https://public.readdy.ai/ai/img_res/594078c26ce4ce8402cea7b98e8895a9.jpg'
    },
    {
      name: 'Tablas',
      description: 'Para revestimientos, pisos y proyectos diversos. Variedad de espesores.',
      image: 'https://readdy.ai/api/search-image?query=Stack%20of%20smooth%20wooden%20planks%20and%20boards%20made%20from%20pine%20radiata%2C%20construction%20grade%20lumber%20with%20visible%20natural%20wood%20grain%2C%20clean%20simple%20light%20beige%20background%2C%20professional%20product%20photography%20showing%20dimensional%20timber%20boards%20for%20flooring%20and%20cladding%20projects%20with%20warm%20natural%20lighting&width=600&height=500&seq=product-tablas-002&orientation=portrait'
    },
    {
      name: 'Vigas',
      description: 'Estructurales de alta resistencia. Para techos y construcciones mayores.',
      image: 'https://readdy.ai/api/search-image?query=Heavy%20duty%20structural%20wooden%20beams%20made%20from%20Chilean%20pine%2C%20large%20dimensional%20lumber%20for%20construction%20and%20roofing%2C%20clean%20simple%20light%20beige%20background%20highlighting%20the%20solid%20wood%20grain%20and%20texture%2C%20professional%20product%20photography%20with%20natural%20warm%20lighting%20showing%20quality%20timber%20beams&width=600&height=500&seq=product-vigas-003&orientation=portrait'
    },
    {
      name: 'Tablones',
      description: 'Madera gruesa para proyectos especiales y construcción robusta.',
      image: 'https://readdy.ai/api/search-image?query=Thick%20wooden%20planks%20and%20heavy%20boards%20made%20from%20pine%20radiata%2C%20robust%20construction%20grade%20lumber%20with%20natural%20wood%20texture%2C%20clean%20simple%20light%20beige%20background%2C%20professional%20product%20photography%20showing%20thick%20dimensional%20timber%20for%20heavy%20duty%20building%20projects%20with%20warm%20natural%20lighting&width=600&height=500&seq=product-tablones-004&orientation=portrait'
    },
    {
      name: 'Costaneras',
      description: 'Para cercos, parcelaciones y uso agrícola. Excelente relación precio-calidad.',
      image: 'https://readdy.ai/api/search-image?query=Rustic%20wooden%20slabs%20and%20edge%20boards%20for%20fencing%20and%20agricultural%20use%2C%20natural%20pine%20lumber%20with%20bark%20edges%2C%20clean%20simple%20light%20beige%20background%2C%20professional%20product%20photography%20showing%20cost%20effective%20timber%20for%20farm%20and%20parcel%20fencing%20with%20warm%20natural%20lighting&width=600&height=500&seq=product-costaneras-005&orientation=portrait'
    },
    {
      name: 'Madera Cepillada',
      description: 'Acabado premium con cepilladora propia. Para tablas de cielo y terminaciones.',
      image: 'https://readdy.ai/api/search-image?query=Smooth%20planed%20and%20finished%20wooden%20boards%20with%20premium%20surface%20quality%2C%20professionally%20milled%20pine%20lumber%20with%20perfect%20smooth%20texture%2C%20clean%20simple%20light%20beige%20background%2C%20professional%20product%20photography%20showing%20high%20grade%20planed%20timber%20for%20ceiling%20boards%20and%20fine%20finishes%20with%20warm%20natural%20lighting&width=600&height=500&seq=product-cepillada-006&orientation=portrait'
    }
  ];

  return (
    <section id="productos" className="py-20 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-5xl font-serif font-bold text-[#5D4037] mb-4">
            Nuestros Productos
          </h2>
          <p className="text-xl text-gray-600 font-light">
            Madera dimensionada para cada necesidad
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="h-64 overflow-hidden bg-[#F5E6D3]">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#5D4037] mb-3 text-center">
                  {product.name}
                </h3>
                <p className="text-gray-600 text-center mb-6 leading-relaxed">
                  {product.description}
                </p>
                <button
                  onClick={handleWhatsAppClick}
                  className="w-full border-2 border-[#5D4037] text-[#5D4037] py-3 rounded-full font-semibold hover:bg-[#5D4037] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Consultar disponibilidad
                </button>
                <p className="text-xs text-gray-400 text-center mt-3 italic">
                  Cortes especiales disponibles
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
